import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { colorMap as tsoColorMap } from '@components/ChipSelector/ChipSelectorTsoPq';
import TypographyTsoPq from '@components/Typography/TypographyTsoPq';
import { Box, styled } from '@mui/material';
import { StyledDataGrid } from '@pages/Masterdata/StyledGridPageComponents';

const colorMap = [
  { min: 50, max: 100, color: tsoPqTheme.palette.customInformation.color_signal_success_success },
  { min: 0, max: 50, color: tsoPqTheme.palette.customInformation.color_signal_warning_warning },
  { min: -Infinity, max: 0, color: tsoPqTheme.palette.customError.color_signal_error_error },
];

export const StyledPqIndexContent = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24,
    padding: `${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_32} 0`,
  };
});

export const StyledTitleWrapper = styled(Box)(() => {
  return {
    width: '79rem',
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_8,
  };
});

export const StyledSplitButtonMenuTsoPqWrapper = styled(Box)(() => {
  return {
    justifyContent: 'center',
    display: 'flex',
  };
});

export const StyledLegendContainer = styled(Box)(() => {
  return {
    display: 'flex',
    justifyContent: 'flex-end',
  };
});

export const StyledCheckboxContainer = styled(Box)(() => {
  return {
    minWidth: '14.035rem',
    display: 'flex',

    '& p': {
      alignSelf: 'center',
    },
  };
});

export const StyledTableContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  };
});

export const StyledRow = styled(Box)(() => {
  return {
    display: 'flex',
    gap: '4px',
  };
});

export const StyledTotalDataPerDeviceGrid = styled(StyledDataGrid)(() => {
  return {
    width: '100px',
  };
});

export const StyledLabel = styled(TypographyTsoPq)(() => {
  return {
    padding: `0 0 0 ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_4}`,
    color: tsoPqTheme.palette.customTextColor.color_neutral_font_ft_nrtrl_enabled,
    fontFamily: tsoPqTheme.typography.openSans,
  };
});

export const StyledGridContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_margin_8,
  };
});

export const StyledRowHeaderCell = styled(Box)(() => {
  return {};
});

export const StyledRowHeaderSubtitle = styled(TypographyTsoPq)(() => {
  return {
    padding: `0 0 0 1.125rem`,
    color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
  };
});

export const TsoIentifier = styled(Box)(({ tso }: { tso: string }) => {
  return {
    alignSelf: 'center',
    background: tsoColorMap[tso as keyof typeof tsoColorMap].active,
    height: '10px',
    width: '10px',
    borderRadius: '50%',
  };
});

export const StyledIndicator = styled(Box)(({ value }: { value: number | undefined }) => {
  const match = colorMap.find((colorValue) => Number(value) >= colorValue.min && Number(value) <= colorValue.max);
  const color = match ? match.color : tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_dark;

  return {
    width: '1.0625rem',
    height: '1.0625rem',
    backgroundColor: color,
    borderRadius: '0.125rem',
  };
});

export const StyledCellValue = styled(TypographyTsoPq)(() => {
  return {
    height: '100%',
    display: 'flex',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
    alignItems: 'center',
    justifyContent: 'flex-start',
  };
});

export const StyledCellHeader = styled(Box)(() => {
  return {
    display: 'flex',
    alignContent: 'center',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
  };
});

export const StyledSpinnerContainer = styled(Box)(() => {
  return {
    display: 'flex',
    justifyContent: 'center',
  };
});
